theme.headerSticky = (function () {
  // Activate sticky only after the user has scrolled this many px past the
  // header's natural position. Reduces the abrupt "snaps in front of the
  // image" feeling on PDP.
  var SCROLL_THRESHOLD = 280;
  var REMOVE_BUFFER = 60; // hysteresis: only un-sticky when scrolled back well above

  function ScrollSticky() {
    var headerStickyWrapper = document.querySelector("header");
    var headerStickyTargetList = document.querySelectorAll(".header__sticky");
    if (!headerStickyWrapper || headerStickyTargetList.length === 0) return;

    var ticking = false;
    function update() {
      var baseTop = TopOffset(headerStickyWrapper).top;
      var addAt = baseTop + SCROLL_THRESHOLD;
      var removeAt = baseTop + REMOVE_BUFFER;
      var y = window.scrollY;
      headerStickyTargetList.forEach(function (target) {
        var isSticky = target.classList.contains("sticky");
        if (!isSticky && y > addAt) {
          target.classList.add("sticky");
        } else if (isSticky && y < removeAt) {
          target.classList.remove("sticky");
        }
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  // Self-invoke on DOM ready so sticky behavior actually fires.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ScrollSticky);
  } else {
    ScrollSticky();
  }

  return ScrollSticky;
})();
